import { useContext } from 'react';
// @ts-expect-error untyped JS module
import formatFraction from '../utils/formatFraction';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedFraction({
  numerator,
  denominator
}) {
  useContext(I18nHMRContext);
  return /*#__PURE__*/_jsx("span", {
    children: formatFraction({
      numerator,
      denominator
    })
  });
}
FormattedFraction.displayName = 'FormattedFraction';
export default FormattedFraction;